import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Link } from "react-router-dom";
import IncomesTable from "../../components/Tables/IncomesTable";
import withPermissions from "../../components/WithPermissions";
import ManagementPageHero from "../../components/ManagementPageHero";

class Incomes extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasNewIncomePermission = userPermissions.includes('new income');
    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Gelirler"
                Breadcrumb={[
                  {name: "Gelir Gider Takibi", navigate: ""},
                  {name: "Gelirler", navigate: ""},

                ]}
            />
            <ManagementPageHero
              eyebrow="GELİR TAKİBİ"
              title="Gelir hareketlerinizi izleyin"
              description="İşletme gelirlerini kategori ve tarihe göre takip edin, yeni gelir kayıtlarını hızla oluşturun."
              actionTo={userHasNewIncomePermission ? "/income-add" : null}
              actionLabel="Yeni gelir"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Gelirler</h2>
                    {userHasNewIncomePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/income-add">Yeni Gelir</Link>
                              </li>

                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}

                  </div>
                  <div className="body">
                    <IncomesTable>

                    </IncomesTable>
                  </div>
                </div>
              </div>
            </div>
            <style>
              <style>
                {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
              </style>
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(connect(mapStateToProps, {})(Incomes));
